export default "__VITE_ASSET__CjG6cpK6__"